import React from 'react';
import styled from 'styled-components';

// Where an item sits in a 3x3 list: a small 3x3 with its square filled. It
// stands where a ranked list shows the item's number: on the item's card,
// over the dark title bar of a carousel slide, and in the list composer.

const Mini = styled.div<{ $size: number }>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: ${(p) => (p.$size >= 26 ? 2 : 1)}px;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
`;

const Square = styled.div<{ $filled: boolean; $onDark: boolean }>`
  border-radius: 1px;
  background: ${(p) =>
    p.$filled ? (p.$onDark ? '#fff' : '#000') : p.$onDark ? 'rgba(255, 255, 255, 0.3)' : '#ddd'};
`;

interface GridSpotProps {
  /** The item's square, 0 to 8, left to right then top to bottom; -1 with
   *  `all` for the whole grid. */
  index: number;
  /** Every square filled: the grid as a whole, not one spot in it. */
  all?: boolean;
  /** White on a dark background (a title bar) rather than black on white. */
  onDark?: boolean;
  size?: number;
}

export default function GridSpot(props: GridSpotProps) {
  const size = props.size || 24;
  return (
    <Mini
      $size={size}
      role={props.all ? undefined : 'img'}
      aria-hidden={props.all ? true : undefined}
      aria-label={props.all ? undefined : 'Spot ' + (props.index + 1) + ' of 9'}
    >
      {Array.from({ length: 9 }, (_, i) => (
        <Square key={i} $filled={!!props.all || i === props.index} $onDark={!!props.onDark} />
      ))}
    </Mini>
  );
}
